import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=659051ea&scoped=true&"
import script from "./RecoverPassword.vue?vue&type=script&lang=js&"
export * from "./RecoverPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=659051ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659051ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VFlex,VForm,VLayout,VTextField})
